// src/data/proyectos/sensorica/sensoricaData.ts

export interface Phase {
  id: number;
  title: string;
  subtitle: string;
  description: string;
  details: string[];
  icon: string;
  color: string;
  image?: string;
  technologies?: string[];
}

export const sensoricaPhases: Phase[] = [
  {
    id: 1,
    title: "1ª FASE",
    subtitle: "Búsqueda de fuentes de contaminación",
    description: "Estudio ambiental de fuentes potenciales de contaminación",
    details: [
      "Identificación de fuentes industriales cercanas",
      "Análisis de vertidos urbanos y agrícolas",
      "Mapeo de zonas de riesgo ambiental",
      "Evaluación de impacto preliminar"
    ],
    icon: "🔍",
    color: "#1976d2",
    image: "/images/proyectos/sensorica/fase1.jpg",
    technologies: ["GIS", "Análisis Ambiental", "Cartografía"]
  },
  {
    id: 2,
    title: "2ª FASE",
    subtitle: "Definir Tipos de Agua",
    description: "Clasificación de tipos de aguas en base a la diversidad ambiental",
    details: [
      "Caracterización de masas de agua",
      "Identificación de patrones de calidad",
      "Definición de categorías según fuentes de contaminación",
      "Establecimiento de líneas base"
    ],
    icon: "💧",
    color: "#0288d1",
    image: "/images/proyectos/sensorica/fase2.jpg",
    technologies: ["Hidrología", "Análisis Químico", "Clasificación"]
  },
  {
    id: 3,
    title: "3ª FASE",
    subtitle: "Sensórica y Caracterización",
    description: "Selección de sensores adecuados para caracterización de tipos de agua",
    details: [
      "Multiparamétrica para parámetros físico-químicos",
      "Sensor de transmitancia para turbidez",
      "Detector de hidrocarburos",
      "Calibración y validación de equipos"
    ],
    icon: "📡",
    color: "#0097a7",
    image: "/images/proyectos/sensorica/fase3.jpg",
    technologies: ["IoT", "Sensores", "Instrumentación"]
  },
  {
    id: 4,
    title: "4ª FASE",
    subtitle: "Sistema de Control y Medida",
    description: "Integración de sensores en sistema de toma de muestras programable",
    details: [
      "Sistema de muestreo multi-punto programable",
      "Protocolo de limpieza automática",
      "Conectividad 4G para transmisión de datos",
      "Interface de programación y visualización",
      "Bajo mantenimiento y alta durabilidad"
    ],
    icon: "⚙️",
    color: "#00796b",
    image: "/images/proyectos/sensorica/fase4.jpg",
    technologies: ["Automatización", "4G/LTE", "SCADA", "PLC"]
  },
  {
    id: 5,
    title: "5ª FASE",
    subtitle: "Base de datos",
    description: "Infraestructura de almacenamiento seguro en servidor VPS dedicado",
    details: [
      "Servidor VPS dedicado con máxima seguridad",
      "Arquitectura escalable y redundante",
      "Protocolos de cifrado de datos",
      "Sistema de backup automático",
      "Optimización para consultas en tiempo real",
      "Parámetros: TEMP, COD, TURB, PH, ION, NON, TSS, LO(longitud de onda)"
    ],
    icon: "🗄️",
    color: "#388e3c",
    image: "/images/proyectos/sensorica/fase5.jpg",
    technologies: ["PostgreSQL", "VPS", "Seguridad", "Cloud"]
  },
  {
    id: 6,
    title: "6ª FASE",
    subtitle: "Clasificación",
    description: "Modelos de Machine Learning para clasificación de tipos de agua",
    details: [
      "K-Nearest Neighbors (KNN)",
      "Support Vector Machines (SVM)",
      "XGBoost para clasificación avanzada",
      "Random Forests para robustez",
      "AdaBoost para optimización",
      "Análisis de precisión y validación cruzada"
    ],
    icon: "🤖",
    color: "#f57c00",
    image: "/images/proyectos/sensorica/fase6.jpg",
    technologies: ["Machine Learning", "Python", "Scikit-learn", "XGBoost"]
  },
  {
    id: 7,
    title: "7ª FASE",
    subtitle: "Plataforma Web",
    description: "Aplicación web con acceso seguro para visualización y análisis",
    details: [
      "Interfaz web responsive y moderna",
      "Acceso seguro mediante autenticación",
      "Visualización en tiempo real de parámetros",
      "Dashboards interactivos de clasificación",
      "Sistema de alertas personalizables",
      "Exportación de datos e informes"
    ],
    icon: "🌐",
    color: "#d32f2f",
    image: "/images/proyectos/sensorica/fase7.jpg",
    technologies: ["Next.js", "React", "TypeScript", "Material-UI"]
  }
];

export const projectOverview = {
  title: "Monitorización de Calidad de Aguas",
  subtitle: "Sistema integral de análisis y clasificación mediante aprendizaje automático",
  description: "Proyecto innovador que combina análisis de datos en tiempo real y algoritmos de Machine Learning para la monitorización continua de la calidad del agua en instalaciones acuícolas.",
  objectives: [
    "Detección temprana de contaminación",
    "Clasificación automática de tipos de agua",
    "Optimización de recursos de mantenimiento",
    "Cumplimiento normativo automatizado"
  ]
};